<div class="skymiles-landing-page-tracker" *ngIf="content.title">
  <div
    class="skymiles-landing-page-tracker__container"
    [ngClass]="{
      'skymiles-landing-page-tracker__container--non-level-wrap': !content.level
    }"
  >
    <div class="skymiles-landing-page-tracker__container__wrap">
      <div class="skymiles-landing-page-tracker__container__wrap__content">
        <div
          class="skymiles-landing-page-tracker__container__wrap__content__subheading"
        >
          {{ content.title }}
        </div>
        <span class="sr-only">
          {{ content.ariaLabels.title }}
        </span>
        <div
          [ngClass]="{
            'skymiles-landing-page-tracker__container__wrap__content--show-text':
              content.level
          }"
        >
          <span
            class="skymiles-landing-page-tracker__container__wrap__content__number"
          >
            {{ content.value }}
          </span>
          <span
            *ngIf="content.level"
            class="skymiles-landing-page-tracker__container__wrap__content__description--show"
          >
            {{ content.description }}
          </span>
        </div>
        <div *ngIf="content.level">
          <span
            *ngIf="content.description"
            class="skymiles-landing-page-tracker__container__wrap__content__description"
          >
            {{ content.description }}
          </span>
        </div>
      </div>
      <div
        [ngClass]="
          content.level
            ? 'skymiles-landing-page-tracker__container__wrap__link'
            : 'skymiles-landing-page-tracker__container__wrap__link--show'
        "
      >
        <span
          *ngIf="!content.level"
          class="skymiles-landing-page-tracker__container__wrap__link__description"
        >
          {{ content.description }}
        </span>
        <div
          class="skymiles-landing-page-tracker__container__wrap__link__label"
          [ngClass]="
            content.level
              ? 'skymiles-landing-page-tracker__container__wrap__link__label--level'
              : 'skymiles-landing-page-tracker__container__wrap__link__label--no-level'
          "
        >
          <idp-link
            *ngIf="content.action"
            [axLabel]="content.action.label"
            [label]="content.action.label"
            [actionUrl]="content.action.url"
            [labelSize]="'double-extra-large'"
            [id]="content.action.id || '#'"
          ></idp-link>
        </div>
      </div>
    </div>

    <div
      *ngIf="!content.level"
      class="skymiles-landing-page-tracker__container__non-level-content"
    >
      <span
        class="skymiles-landing-page-tracker__container__non-level-content__description"
      >
        {{ content.description }}
      </span>
      <div
        class="skymiles-landing-page-tracker__container__non-level-content__label"
      >
        <idp-link
          [axLabel]="content.action.label"
          [label]="content.action.label"
          [actionUrl]="content.action.url"
        ></idp-link>
      </div>
    </div>
    <div class="skymiles-landing-page-tracker__container__image-content">
      <div *ngIf="content.level">
        <div
          [class]="
            'skymiles-landing-page-tracker__container__image-content__image--' +
            (content.level === '0' ? 'non-million' : 'default')
          "
          [ngStyle]="getLogoClass(content.level)"
        >
          <span class="sr-only">
            {{ content.ariaLabels.level }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
